<div
  *transloco="let t; read: 'calculator_result.result.values.user-investment'"
  class="flex flex-col font-bold">
  <psc-section-title
    class="mb-2"
    [title]="t('title')"
    alignment="left"
    [color]="colorConfig.textColor"
    [lineColor]="colorConfig.bgColor"
    [size]="smallTitle ? 'small' : 'normal'"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>


  <!--   t(investment.title, investment.info, investment-return.title, investment-return.info, life-savings.title, life-savings.info) -->
  <psc-value-text
    *ngFor="let value of userInvestmentValues; let even = even"
    [coloredRow]="even"
    [coloredRowColor]="colorConfig.bgColor"
    [primaryTextColor]="colorConfig.textColor"
    [secondaryTextColor]="colorConfig.textColor"
    [label]="t(value.labelKey + '.title')"
    [value]="value.value"
    [unit]="value.unit"
    [infoText]="t(value.labelKey + '.info')"
  ></psc-value-text>
</div>
